//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_LOGIN = "login";

/**
 *
 * @type {string}
 */
export const POST_PASSWORD_VERIFIED = "/password-verified";
export const SEND_EMAIL_VERIFICATION = "/email/send-verification";
export const GET_DATA_ADIC_ACCOUNT = "/user/data-adic";

export const INVOICE_GET_LIST = "/invoice/get-list"
export const INVOICES_ROWS_UPLOAD = "/invoice/upload"

export const AREAS_GET = "/config/get-areas"
export const AREA_SAVE = "/area/save"
export const AREA_UPDATE = "/area/update"

export const SOURCE_FINANCING_SAVE = "/config/source-financing-save"

export const CATS_LIST_GET = "/cats/get-list"

export const CONFIG_INIT_GET = "/config/get"

export const CONFIG_LETTERHEAD_IMAGE_UPLOAD = "/config/letterhead-save"
export const CONFIG_LOGO_IMAGE_UPLOAD = "/config/logo-save"

export const CONFIG_INIT_SAVE = "/config/city-hall-save"

export const COMISSION_FINANCE_SAVE = "/config/commission-finance-save"

export const TRIGGER_POSITIONS_SAVE = "/config/positions-trigger"

export const GET_REQUISITON_LIST = "/requisition/list"
export const GET_DOCUMENT_DOWN = "/requisition/get-document"
export const GET_DOCUMENT_ALL_DOWN = "/requisition/get-documents"

export const SAVE_REQUISITON = "/requisition/save"

export const GET_CITY_HALLS_BY_USER = "/user/get-city-halls"

/**
 * AREAS
 */
export const GET_AREAS = "/area/list";
export const ADD_NEW_AREA = "/area/save";
export const UPDATE_AREA = "/area/update";
export const DELETE_AREA = "/area/delete";

/**
 * PROPERTIES
 */
export const GET_PROPERTIES = "/property/list";
export const GET_PROPERTY_QR = "/property/generate-qr";
export const GET_PROPERTY_RECEIPT = "/property/generate-receipt";
export const ADD_NEW_PROPERTY = "/property/save";
export const UPDATE_PROPERTY = "/property/update";
export const DELETE_PROPERTY = "/property/delete";
export const UPLOAD_IMAGES_FOR_PROPERTY = "/property/upload-images";
export const DELETE_IMAGE_FOR_PROPERTY = "/property/delete-image";

/**
 * TYPE PROPERTIES
 */
export const GET_TYPE_PROPERTIES = "/type-property/list";
export const ADD_NEW_TYPE_PROPERTY = "/type-property/save";
export const UPDATE_TYPE_PROPERTY = "/type-property/update";
export const DELETE_TYPE_PROPERTY = "/type-property/delete";

export const GET_REPORT_PROPERTIES = "/reports/get-properties";
export const GET_BROCHURE = "/reports/get-brochure";
export const GET_BROCHURE_LIST = "/generated-file/get-brochure-list";
export const GET_REPORT_PROPERTIES_DISCONTINUED = "/reports/get-properties-discontinued";
